module.exports = __webpack_public_path__ + "img/campana.2bafbcb0.svg";